import React from "react";
import { arrayOf, shape, string } from "prop-types";
import SectionHeading from "../../molecules/SectionHeading";
import CardsGrid from "../../molecules/CardsGrid";
import SectionLink from "../../atoms/SectionLink";

import "../_shared/section-styles.m.css";

const EventsSection = ({
  tags,
  highlightText,
  cards,
  linkHref,
  highlightHeading,
  eventType = "events",
  ...props
}) => {

  const strongText = highlightHeading?.match(/<strong>(.*?)<\/strong>/)[1].trim();
  const normalText = highlightHeading
    ?.replace(/.*<\/strong>/, '')
    ?.replace(/<\/?p>/g, '')
    ?.trim();

  const linkTextMap = {
    workshops: "Upcoming workshops and archive",
    sessions: "Upcoming sessions and archive",
    conferences: "Upcoming conferences and archive"
  };

  const linkText = linkTextMap[eventType] || `Upcoming ${eventType} and archive`;

  return (
    <section styleName="section-container" {...props}>
      <div styleName="section-content">
        <SectionHeading
          tags={tags}
          highlightText={strongText}
          normalText={normalText}
        />

        {highlightText && (
          <div styleName="section-highlight-text">
            <p>{highlightText}</p>
          </div>
        )}

        {cards && <CardsGrid cards={cards} />}

        <SectionLink href={linkHref}>
          {linkText}
        </SectionLink>
      </div>
    </section>
  );
};

EventsSection.propTypes = {
  tags: arrayOf(string),
  highlightText: string,
  cards: arrayOf(shape({
    title: string.isRequired,
    content: string.isRequired
  })),
  linkHref: string,
  highlightHeading: string,
  eventType: string
};

export default EventsSection;